import moment from 'moment';

const Footer = () => {
	return <div className={'tt-footer'}>&copy; {moment().format('YYYY')}</div>;
};

export default Footer;
